"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Contact = void 0;
const react_1 = __importDefault(require("react"));
const theme_1 = __importDefault(require("../styles/theme"));
const styled_div_1 = require("./styled-div");
const uplift_icons_1 = require("./uplift-icons");
const link_1 = require("./link");
const Contact = ({ className, id, style, phone, phoneLabel, email, size = 12, }) => {
    const textStyle = {
        fontSize: `${size}px`,
        padding: '0px 5px',
        lineHeight: 1,
        width: 'auto',
    };
    return (react_1.default.createElement(styled_div_1.StyledDiv, { "data-testid": "contact-div", className: className, id: id, style: Object.assign({ alignItems: 'center', display: 'flex' }, style) },
        phone && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(uplift_icons_1.Phone, { size: size, color: theme_1.default.colors.iconGrey }),
            react_1.default.createElement(link_1.Link, { style: textStyle, href: `tel:${phone}`, underline: false }, phoneLabel || phone))),
        email && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(uplift_icons_1.Envelope, { size: size, color: theme_1.default.colors.iconGrey }),
            react_1.default.createElement(link_1.Link, { style: textStyle, href: `mailto:${email}`, underline: false }, email)))));
};
exports.Contact = Contact;
exports.default = exports.Contact;
